import { msg, str } from '@lit/localize';
const supportTypes = [
    {name:"AccessAuditing", label:msg(`Access auditing`)},
    {name:"AudioDescription", label:msg(`Audio Description`)},
    {name:"Braille", label:msg(`Braille`)},
    {name:"BritishSignLanguage", label:msg(`British Sign Language`)},
    {name:"Captioning", label:msg(`Captioning`)},
    {name:"Coaching", label:msg(`Coaching`)},
    {name:"Consultancy", label:msg(`Consultancy`)},
    {name:"EasyRead", label:msg(`Easy Read`)},
    {name:"InterpretationProvider", label:msg(`Interpretation Provider`)},
    {name:"IrishSignLanguage", label:msg(`Irish Sign Language`)},
    {name:"KnowledgeBase", label:msg(`Knowledge Base`)},
    {name:"Makaton", label:msg(`Makaton`)},
    {name:"Marketing", label:msg(`Marketing`)},
    {name:"Mentoring", label:msg(`Mentoring`)},
    {name:"SupportLine", label:msg(`Support Line`)},
    {name:"SignSupportedEnglish", label:msg(`Sign Supported English`)},
    {name:"Software", label:msg(`Software`)},
    {name:"Streaming", label:msg(`Streaming`)},
    {name:"Training", label:msg(`Training`)},
    {name:"UsabilityTesting", label:msg(`Usability Testing`)}
];

const operationIn = [
    {name:"England", label:msg(`England`)},
    {name:"Scotland", label:msg(`Scotland`)},
    {name:"Wales", label:msg(`Wales`)},
    {name:"NorthernIreland", label:msg(`Northern Ireland`)},
    {name:"Ireland", label:msg(`Ireland`)},
    {name:"Online", label:msg(`Online`)}
];


const artforms = [
    {name:"CombinedArts", label:msg(`Combined Arts`)},
    {name:"Craft", label:msg(`Craft`)},
    {name:"Dance", label:msg(`Dance`)},
    {name:"Festivals", label:msg(`Festival`)},
    {name:"FilmOrScreen", label:msg(`Film/Screen`)},
    {name:"Libraries", label:msg(`Libraries`)},
    {name:"Literature", label:msg(`Literature`)},
    {name:"Museums", label:msg(`Museums`)},
    {name:"Music", label:msg(`Music`)},
    {name:"PerformingArts", label:msg(`Performing Arts`)},
    {name:"Theatre", label:msg(`Theatre`)},
    {name:"VisualArts", label:msg(`Visual Arts`)},
];

const languages = [
    {name: 'en', label: 'English'},
    {name: 'cy', label: 'Cymraeg'},
   // {name: 'ga', label: 'Gaeilge'},
    {name: 'gd', label: 'Gaelic'}
];

const processProfileData = (_profileData, support_org_language_texts) => {
    //console.log('processProfileData', _profileData);
    if(_profileData?.draftInfo){
        let draftInfo = JSON.parse(_profileData.draftInfo);
        _profileData = {..._profileData, ...draftInfo};
    }
    let returnData = [
        {name:'logo', type:'file', title:msg(`Logo`), value:'', description:msg(str``), error_message:msg(str`Please upload a logo for your Support profile`)},
        {name:'name', type:'text',title:msg(`Name`), value:_profileData?.name, 'required':true, description:msg(str``), error_message:msg(str`Please enter the name of your Support profile`)},
        //{name:'language', type:'select', title:msg(`What is the language of your organisation?`), value:_profileData?.language, 'required':true, options:languages, description:msg(str`What language will you be submitting this profile in?`), error_message:msg(str`Please select the language for your Support profile`)},
        {name:'language', type:'select', title:support_org_language_texts?.support_org_language || msg(`What is the language of your organisation?`), value:_profileData?.language, 'required':true, options:languages, description:support_org_language_texts?.support_org_language_description || msg(str`What language will you be submitting this profile in?`), error_message:support_org_language_texts?.support_org_language_error || msg(str`Please select the language for your Support profile`)},
        {name:'description', type:'textarea', title:msg(`Description`), value:_profileData?.description, 'required':true, description:msg(str``), error_message:msg(str`Please enter a description of your Support profile`)},
        {name:'website', type:'url', title:msg(`Website`), value:_profileData?.website,  description:msg(str``), error_message:msg(str`Please enter the website for your Support profile`)},
        {name:'email', type:'email', title:msg(`Email`), value:_profileData?.email, description:msg(str``), error_message:msg(str`Please enter the email address for your Support profile`)},
        {name:'phone', type:'text', title:msg(`Phone`), value:_profileData?.phone,  description:msg(str``), error_message:msg(str`Please enter the phone number for your Support profile`)},
        {name:'operationIn', type:'multiselect', title:msg(`Areas of operation`), value:_profileData?.operationIn,  options:operationIn, description:msg(str``), error_message:msg(str`Please select the areas in which your Support profile operates`)},
        {name:'supportTypes', type:'multiselect', title:msg(`Types of support offered`), value:_profileData?.supportTypes,  options:supportTypes, description:msg(str``), error_message:msg(str`Please select the types of support offered by your Support profile`)},
        {name:'artforms', type:'multiselect', title:msg(`Artforms supported`), value:_profileData?.artforms,  options:artforms, description:msg(str``), error_message:msg(str`Please select the artforms supported by your Support profile`)},
    ]
    //console.log('returnData', returnData);
    return returnData;
}

export {supportTypes, operationIn, artforms, processProfileData};